/**
 * 历史开奖形态入口
 */
import RuleEngine from '../../../../helpers/rules-engine'

// 以下是规则文件
import Mathcher from './rule-recentCode-mathch'
import Decision from './rule-recentCode-decision'
import Ending from './rule-recentCode-ending.js'


// 合并所有规则
let rules = _.concat(
                    Mathcher(),
                    Decision(),
                    Ending()
                )

let R = new RuleEngine();
R.register(rules);


/**
 * 执行规则入口
 * @author ammo 2018-06-19
 * @param  {[type]}   currentMethod [当前选中玩法]
 * @param  {[type]}   historyCodes  [最近开奖]
 * @param  {Function} callback      [回调]
 * @return {[type]}                 [description]
 */
export function execute(currentMethod, historyCodes, callback){
    // 等待处理的对象
    let pending = {
        currentMethod,
        historyCodes
    }

	R.execute(pending, function(data) {
        callback(data.done)
	});
}